import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import './LegalPage.css';

export default function PrivacyPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="legal-page">
      <div className="legal-inner">
        <Link to="/" className="legal-back">← Back to Home</Link>
        <h1 className="legal-title">Privacy Policy</h1>
        <p className="legal-updated">Last updated: May 20, 2026</p>

        <h2>1. Introduction</h2>
        <p>This Privacy Policy explains how Lexira ("we", "our", "us") collects, uses, and protects information when you use the Lexira mobile application.</p>

        <h2>2. Information We Collect</h2>
        <p><strong>Information You Provide:</strong> Account information (email address, display name, and password when you register) and feedback you submit through the in-app feedback feature.</p>
        <p><strong>Information Collected Automatically:</strong> Gameplay data (levels completed, stars earned, words found, session duration, daily streak count), device information, analytics events, and anonymized crash reports.</p>
        <p><strong>Information from Third Parties:</strong> If ads are enabled, third-party ad networks may collect identifiers (IDFA/GAID) subject to your device-level consent settings.</p>

        <h2>3. How We Use Your Information</h2>
        <table>
          <thead>
            <tr><th>Purpose</th><th>Legal Basis</th></tr>
          </thead>
          <tbody>
            <tr><td>Provide and operate the App</td><td>Contract performance</td></tr>
            <tr><td>Sync progress across devices</td><td>Contract performance</td></tr>
            <tr><td>Improve game balance and features</td><td>Legitimate interest</td></tr>
            <tr><td>Send important service notifications</td><td>Contract performance</td></tr>
            <tr><td>Serve personalized ads (if enabled)</td><td>Consent</td></tr>
            <tr><td>Comply with legal obligations</td><td>Legal obligation</td></tr>
          </tbody>
        </table>

        <h2>4. Data Sharing</h2>
        <p>We do not sell your personal data. We may share data with:</p>
        <ul>
          <li><strong>Service providers</strong> (cloud hosting, analytics, crash reporting) under data processing agreements.</li>
          <li><strong>Ad networks</strong> (only with your consent and only for advertising purposes).</li>
          <li><strong>Law enforcement</strong> when required by applicable law.</li>
        </ul>

        <h2>5. Data Retention</h2>
        <p>We retain your account data for as long as your account is active. You may request deletion at any time (see Section 8). Anonymized analytics data may be retained longer for statistical purposes.</p>

        <h2>6. Children's Privacy</h2>
        <p>The App is not directed to children under 13. We do not knowingly collect personal information from children under 13. If you believe a child under 13 has provided us with personal information, contact us at <a href="mailto:privacy@lexira.app">privacy@lexira.app</a> and we will delete it promptly.</p>

        <h2>7. Security</h2>
        <p>We implement industry-standard security measures including HTTPS encryption, hashed passwords, and restricted data access. No method of transmission over the internet is 100% secure; we cannot guarantee absolute security.</p>

        <h2>8. Your Rights</h2>
        <p>Depending on your jurisdiction, you may have the right to access, correct, delete, or export your personal data, and to opt out of personalized advertising. To exercise any of these rights, email <a href="mailto:privacy@lexira.app">privacy@lexira.app</a> with the subject line "Data Request".</p>

        <h2>9. Cookies &amp; Tracking</h2>
        <p>The App itself does not use browser cookies. If you access our website, standard web cookies may be used for analytics. You can control cookies via your browser settings.</p>

        <h2>10. Third-Party Links</h2>
        <p>The App may contain links to third-party services (e.g., app stores). We are not responsible for the privacy practices of third parties.</p>

        <h2>11. Changes to This Policy</h2>
        <p>We may update this Privacy Policy. We will notify you via the App or email for material changes. The "last updated" date at the top reflects the most recent revision.</p>

        <h2>12. Contact</h2>
        <p>
          For privacy questions or data requests:<br />
          <strong>Email:</strong> <a href="mailto:privacy@lexira.app">privacy@lexira.app</a><br />
          <strong>Developer:</strong> Mohammad Reza / Lexira Team
        </p>
      </div>
    </div>
  );
}
